<p-progressSpinner class="resy_spinner spinner_in_front" *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
  <div class="pb-2">
    <div>
      <label class="mb-2 lbl_resy_field">{{'RESERVATION.CHOOSE_DATE' | translate}}
        <i *ngIf="errorModel!=null && errorModel['DateRange']!=null"
           class="pi pi-exclamation-circle float-end me-1 error_color"
           pTooltip="{{errorModel['DateRange']|translate}}" tooltipPosition="top"></i>
      </label>
      <p-calendar #rangeCalendar class="range-date-picker" [(ngModel)]="dateRange"
                  selectionMode="range" [readonlyInput]="true" inputId="range" [showIcon]="true"
                  [firstDayOfWeek]="1" styleClass="higher-input">
        <ng-template pTemplate="date" let-date>
          <div class="calendar-item"
               [ngClass]="{range_selecting: isRangeDate(date, 0, true),
                             endpoint_start: isRangeDate(date, 0),
                             endpoint_end: isRangeDate(date, 1)}">
            <span class="date">{{ date.day }}</span>
          </div>
        </ng-template>
      </p-calendar>
    </div>
  </div>
  <div class="d-flex flex-row w-100" style="gap: 10px;">
    <button class="btn_without_color m-0 mt-3 w-50" (click)="downloadFile(exportDataModel)">
      <img src="assets/icons/download_24px_white.svg" alt="download_icon">
    {{'RESERVATION.DOWNLOAD' | translate}}</button>
    <button class="btn_login m-0 mt-3 mb-1 w-50" (click)="sendFileToEmail(exportDataModel)">{{'RESERVATION.SEND_TO_EMAIL' | translate}}</button>
  </div>
</div>
<p-toast position="bottom-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [styleClass]="'popup-toast'"></p-toast>
